
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.667 25.063a1.91 1.91 0 01-.9-.228 1.886 1.886 0 01-.996-1.668v-1.539c-3.272-.335-5.417-2.74-5.417-6.185v-6.5c0-3.727 2.503-6.23 6.23-6.23h10.833c3.726 0 6.229 2.503 6.229 6.23v6.5c0 3.726-2.503 6.229-6.23 6.229h-4.084l-4.615 3.076a1.925 1.925 0 01-1.05.314zM7.583 4.328c-2.795 0-4.604 1.809-4.604 4.604v6.5c0 2.795 1.81 4.604 4.604 4.604.444 0 .813.368.813.812v2.308c0 .14.086.206.14.238a.263.263 0 00.282-.01l4.821-3.207a.835.835 0 01.455-.141h4.333c2.796 0 4.605-1.81 4.605-4.604v-6.5c0-2.795-1.81-4.604-4.605-4.604H7.583z","fill":"#37F"}}),_c('path',{attrs:{"d":"M13 14.002a.818.818 0 01-.813-.813v-.227c0-1.257.921-1.874 1.268-2.113.4-.27.53-.455.53-.736A.99.99 0 0013 9.127a.99.99 0 00-.986.986.818.818 0 01-.813.812.818.818 0 01-.812-.812c0-1.441 1.17-2.611 2.61-2.611 1.442 0 2.612 1.17 2.612 2.61 0 1.236-.91 1.853-1.246 2.08-.423.282-.553.466-.553.77v.227a.811.811 0 01-.812.813zM13 16.7a.811.811 0 11-.002-1.624A.811.811 0 0113 16.7z","fill":"#37F"}})])
          )
        }
      }
    